/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

import Graphql from '@/services/Graphql'
import Logger from '@/services/Logger'
import find from 'lodash/find'
import sortBy from 'lodash/sortBy'
import Config from '@/config'
import HttpProvider from '@/services/HttpProvider'
import { manageAttributesLabel } from '@/helpers/utils'

export default {
  load (ctx, sku) {
    return Graphql.genericCallCash({
      token: ctx.rootState.user.token,
      storeViewCode: ctx.rootState.ui.storeViewCode,
      graphSchemaType: 'graphProduct',
      variables: {
        sku: {
          eq: `${sku}`
        }
      }
    })
      .then(resp => {
        let product = resp.data.products.items[0]
        ctx.commit('setCurrent', product)
        return product
      })
  },
  find (ctx, sku) {
    return ctx.dispatch('load', sku)
  },
  loadByUrlKey (ctx, slug) {
    let urlKey = slug.replace('.html', '').substr(slug.lastIndexOf('/') + 1)
    return Graphql.genericCallCash({
      token: ctx.rootState.user.token,
      storeViewCode: ctx.rootState.ui.storeViewCode,
      graphSchemaType: 'graphProduct',
      variables: {
        filter: {
          url_key: {
            eq: `${urlKey}`
          }
        }
      }
    })
      .then(resp => {
        if (resp.data && resp.data.products) {
          let product = resp.data.products.items.length ? resp.data.products.items[0] : {}
          // set link product
          let beforePath = '/' + ctx.rootState.ui.storeViewCode + '/'
          product.productLink = beforePath + product.url_key + product.url_suffix
          if (product.attributesLabel.length) {
            product.attributesLabel = manageAttributesLabel(product.attributesLabel)
            // sort position media_gallery
            product.media_gallery = sortBy(product.media_gallery, ['position'])
          }
          ctx.commit('setCurrent', product)
          return product
        } else {
          Logger.error(resp)
        }
      })
  },
  loadConfigurableByUrlKey (ctx, urlKey) {
    return Graphql.genericCall(
      {},
      ctx.rootState.user.token,
      ctx.rootState.ui.storeViewCode,
      'productConfigurable',
      {
        filter: {
          url_key: {
            eq: urlKey
          }
        }
      },
      false // cache false
    )
      .then(resp => {
        if (resp.data && resp.data.products) {
          let product = resp.data.products.items.length ? resp.data.products.items[0] : {}
          ctx.commit('updateCurrentVariant', product)
          return product
        } else {
          Logger.error(resp)
        }
      })
  },
  suggestions (ctx, { inputText }) {
    // genericCall (config, token, storeViewCode, graphSchemaType, variables = null, useCache = true)
    return Graphql.genericCallCash({
      token: ctx.rootState.user.token,
      storeViewCode: ctx.rootState.ui.storeViewCode,
      graphSchemaType: 'suggestionsProduct',
      variables: {
        inputText
      }
    })
      .then(resp => {
        if (resp && resp.data && resp.data.products) {
          resp.data.products.categoryAggregations = find(resp.data.products.aggregationsStore, { attribute_code: 'category_id' })
          ctx.commit('setSuggestions', resp.data.products)
          return resp.data.products
        }
        return {}
      })
      .catch(err => {
        Logger.error(err)
        return []
      })
  },
  clearSuggestions (ctx) {
    ctx.commit('setSuggestions', {})
  },
  setNotify (ctx, { email, productId }) {
    let url = Config.API.catalog.notifyMe
    let stockAlert = {
      'customer_email': email,
      'product_id': productId,
      'website_id': ctx.rootGetters['storeConfig/websiteId'],
      'store_id': ctx.rootGetters['storeConfig/storeviewID']
    }

    return HttpProvider.post(url,
      { stockAlert },
      {
        headers: {
          'Authorization': `Bearer ${process.env.VUE_APP_MAGENTO_TOKEN}`
        }
      })
      .catch(error => {
        throw error
      })
  }
}
